"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objectStorageFactory = void 0;
function objectStorageFactory() {
    let memoryStorage = {};
    function clear() {
        memoryStorage = {};
    }
    function getItem(key) {
        return memoryStorage.hasOwnProperty(key) ? memoryStorage[key] : null;
    }
    function key(index) {
        return Object.keys(memoryStorage)[index] || null;
    }
    function removeItem(key) {
        delete memoryStorage[key];
    }
    function setItem(key, value) {
        memoryStorage[key] = value;
    }
    function length() {
        return Object.keys(memoryStorage).length;
    }
    return {
        key,
        clear,
        getItem,
        setItem,
        removeItem,
        get length() {
            return length();
        },
    };
}
exports.objectStorageFactory = objectStorageFactory;
